import services from 'services'

export default {

  get(context, uuid) {
    return services.fetch(`/v1/messages/${context}/${uuid}`)
  },

  putVideoResponse(context, uuid, videoResponse) {
    return services.fetch(
      `/v1/messages/${context}/${uuid}`,
      {
        method: 'PUT',
        body: videoResponse,
      },
    )
  },

  putMobileVideoResponse(context, uuid, videoResponse) {
    return services.fetch(
      `/v1/messages/${context}/${uuid}/mobile-response`,
      {
        method: 'PUT',
        body: videoResponse,
      },
    )
  },

  deleteVideoResponse(context, uuid, videoResponse) {
    return services.fetch(
      `/v1/messages/${context}/${uuid}`,
      {
        method: 'DELETE',
        body: videoResponse,
      },
    )
  },

  fetchOpentokSessionData(context, uuid) {
    return services.fetch(`/v1/messages/${context}/opentok-session/${uuid}`)
  },
}
